export default __webpack_public_path__ + "static/media/hotels.2b3e9afe.PNG";